


export default class Modal {
    overlay: HTMLElement;
    modals: NodeList;
    openButtons: NodeList;
    donationBlocks: NodeList;
    focusableEls: string;
    KEYCODE_TAB: number;
    KEYCODE_ESC: number;

    stickyDonationCtas: NodeList;

    constructor() {
        this.overlay = document.querySelector('.acc-modal-overlay');
        this.modals = document.querySelectorAll('.acc-modal');
        this.openButtons = document.querySelectorAll('[data-modal-target]');
        this.donationBlocks = document.querySelectorAll('.stepped-donation-block, .modal-btn-parent');
        
        this.focusableEls =
            'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])';
        this.KEYCODE_TAB = 9;
        this.KEYCODE_ESC = 27;

        this.stickyDonationCtas = document.querySelectorAll('.sticky_donate .sticky_donate_buttons button, .donate_confirm .donate_confirm_buttons button');

    }

    init() {

        if (this.modals.length > 0 && this.overlay !== null) {
            Array.prototype.forEach.call(this.modals, modal => {
                const modalCloseBtns = modal.querySelectorAll('[data-modal-close]');
                const videoPlayers: NodeListOf<HTMLIFrameElement> = modal.querySelectorAll('.liquid-video-wrapper iframe');

                if (modalCloseBtns.length > 0) {
                    Array.prototype.forEach.call(modalCloseBtns, closeBtn => {
                        closeBtn.addEventListener('click', () => {
                            if (videoPlayers.length) {
                                this.stopVideoPlayers(videoPlayers);
                            }
                            this.hide(modal);
                        });
                    });
                }

                this.keyboardHandler(modal, videoPlayers);
            });

            if (this.stickyDonationCtas.length > 0) {
                Array.prototype.forEach.call(this.stickyDonationCtas, stickyDonateBtn => {
                    stickyDonateBtn.addEventListener('click', () => {
                        this.show(stickyDonateBtn, true, 1);
                    });
                });
            }


            //if (this.openButtons.length > 0) {
            //    Array.prototype.forEach.call(this.openButtons, openButton => {

            //        openButton.addEventListener('click', () => {
            //            console.log('2');

            //            this.show(openButton, true, 1);
            //        });
            //    });
            //}

            //////////////////////
            // Delegation is good
            if (this.donationBlocks.length > 0) {
                Array.prototype.forEach.call(this.donationBlocks, donationBlock => {

                    donationBlock.addEventListener('click', (e) => {

                        var t = e.target;
                        var button;

                        //console.log(t, t.closest('[data-modal-target]'));

                        if (button = t.closest('[data-modal-target]'))
                            this.show(button, true, 1);
                    });
                });
            }
            // Reinstate the open button behaviours as these are needed elsewhere on the site
            else if (this.openButtons.length > 0) {
                Array.prototype.forEach.call(this.openButtons, openButton => {

                    openButton.addEventListener('click', () => {

                        this.show(openButton, true, 1);
                    });
                });
            }
        }
    }

    stopVideoPlayers(playerElements) {
        Array.prototype.forEach.call(playerElements, player => {
            player.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        });
    }

    show(targetID, multiStep = false, step) {
        var target = targetID;
        var urlTarget = "";
        var value = 0;
        var redirectUrl = "";

        if (typeof targetID === 'object' && typeof targetID.nodeType !== undefined) {
            target = targetID.dataset.modalTarget;
            urlTarget = targetID.dataset.urlTarget;
            value = targetID.value;
            redirectUrl = urlTarget + "?amount=" + value;
            targetID.setAttribute('aria-expanded', 'true');
        }

        var modal = document.querySelector(`#${target}`)
        var submitButtonRegular = document.querySelector('#complete.regular-complete');
      
        if (modal !== null) {
            var modalForm = document.querySelector(`[data-modal=${target + step}]`)
            if (!multiStep) {
                modal.querySelector('.acc-modal-overlay').classList.add('is-active');
                setTimeout(() => {
                    modalForm.classList.add('is-active');
                    this.fireEvent('onDonationModalShowStep');
                }, 0);
            } else {
                modal.querySelector('.acc-modal-overlay').classList.add('is-active');
                modalForm.classList.add('is-active');
                this.fireEvent('onDonationModalShowStep');
            }

            modalForm.classList.remove('is-d-none');
            modalForm.setAttribute('aria-hidden', 'false');
            const firstfocusableEl: HTMLElement = modal.querySelectorAll(this.focusableEls)[0] as HTMLElement;

            if (firstfocusableEl !== null) {
                setTimeout(() => {
                    firstfocusableEl.focus();
                }, 300);
            }
            document.body.classList.add('has-no-scroll');

            if (submitButtonRegular !== null)
                submitButtonRegular.setAttribute('disabled', 'disabled');

        }
        else {
            document.location.href = redirectUrl;
        }
    }

    hide(targetID, multiStep = false) {
        let target = targetID;

        if (typeof targetID === 'object' && typeof targetID.nodeType !== undefined) {

            target = targetID;
            let openBtns: NodeListOf<HTMLElement> = document.querySelectorAll(`[data-modal="${targetID}"]`);
            
            if (openBtns.length > 0) {
                Array.prototype.forEach.call(openBtns, openBtn => {
                    openBtn.setAttribute('aria-expanded', 'false');
                });
                openBtns[0].focus();
            }
        } else {
            target = document.querySelector(`[data-modal="${targetID}"]`);
        }
        if (multiStep) {
            if (target) {
                target.classList.remove('is-active');
                target.classList.add('is-d-none');
            }
        } else {
            const modalContainer = `#${target.getAttribute('data-modal').slice(0, -1)}`
            const modal: HTMLElement = document.querySelector(modalContainer);
            modal.querySelector('.acc-modal-overlay').classList.remove('is-active');
            target.classList.remove('is-active');
            target.classList.add('is-d-none');
            target.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('has-no-scroll');
        }
    }

    /* TODO: this should not be tied to the donation-steps class in an ideal world */
    getActiveStepTitle() {
        const activeModal = document.querySelector('.donation-form-modal.is-active') as HTMLElement;
        if (activeModal) {
            const activeTitle = activeModal.querySelector('.donation-steps-nav .is-active') as HTMLElement;
            return activeTitle ? activeTitle.innerText : '(unknown step)';
        }

        return '(unknown step)';
    }

    keyboardHandler(modal, videoPlayers) {
        const focusableEls = modal.querySelectorAll(this.focusableEls);

        document.addEventListener('keydown', event => {
            const tabPressed = event.keyCode === this.KEYCODE_TAB;
            const escPressed = event.keyCode === this.KEYCODE_ESC;

            if (!escPressed && !tabPressed) {
                return;
            }

            if (escPressed) {
                if (modal.classList.contains('is-active')) this.hide(modal);

                if (videoPlayers.length) {
                    this.stopVideoPlayers(videoPlayers);
                }
            }

            if (focusableEls.length > 0) {
                const firstFocusableEl = focusableEls[0];
                const lastFocusableEl = focusableEls[focusableEls.length - 1];

                if (tabPressed) {
                    if (event.shiftKey) {
                        if (document.activeElement === firstFocusableEl) {
                            lastFocusableEl.focus();
                            event.preventDefault();
                        }
                    } else {
                        if (document.activeElement === lastFocusableEl) {
                            firstFocusableEl.focus();
                            event.preventDefault();
                        }
                    }
                }
            }
        });
    }

    fireEvent(event) {
        let eventObj;

        if (typeof (Event) === 'function') {
            eventObj = new Event(event);
        } else {
            eventObj = document.createEvent('Event');
            eventObj.initEvent(event, false, false);
        }

        document.dispatchEvent(eventObj);
    }
}
